module.exports = __webpack_public_path__ + "img/ai_nav_icon.04818223.png";